import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import body1 from "../components/Text/Body1.vue";
import body2 from "../components/Text/Body2.vue";
import body3 from "../components/Text/Body3.vue";
import herotext from "../components/Text/HeroText.vue";
import subtitle1 from "../components/Text/Subtitle1.vue";
import subtitle2 from "../components/Text/Subtitle2.vue";

const vuetify = createVuetify({
  components: {
    ...components,
    herotext,
    subtitle1,
    subtitle2,
    body1,
    body2,
    body3,
  },
  directives,
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        colors: {
          primary: "#333333",
          error: "#C42010",
          background: "#ffffff",
        },
      },
      dark: {
        colors: {
          primary: "#333333",
          error: "#C42010",
          background: "#0A201D",
        },
      },
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    global: {
      ripple: false,
    },
    VTextField: {
      variant: "outlined",
    },
    VBtn: {
      variant: "text",
    },
  },
});

export default vuetify;
